import React, { useContext } from 'react';

import {
    api,
    PortalContext,
    HomeWidgetVacio,
    HomeWidgetError,
    useMsal
} from '@portal/arq-portal-core';
import {
    makeStyles,
    Typography,
    CircularProgress
} from '@material-ui/core';
import useSWR from 'swr';

import { MeInteresaTabs } from './MeInteresaTabs';
//import { getDefaultNormalizer } from '@testing-library/dom';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
        minHeight: "284px",
        position: 'relative',
        '& .MuiTabScrollButton-root.Mui-disabled': {
            opacity: "0.3",
        },
        '@media screen and (max-width: 767px)': {
            minHeight: 'auto',
            float: 'left',
            width: '100%',
            marginBottom: '15px'
        },
    },
    contenedor: {
        display: 'block',
        width: '100%',
        float: 'left',
        maxHeight: '243px',

    },
    tituloPreTabs: {
        alignSelf: "center",
        minHeight: "46px",
        float: "left",
        verticalAlign: "middle",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderBottom: "1px solid #919191",
        paddingBottom: "2px",
        '&:before': {
            content:'""',
            position: "absolute",
            width: "100%",
            borderBottom: "1px solid #919191",
            left: "0px",
            top: "48px"
        },
        '@media screen and (max-width: 767px)': {
            width:"100%",
        },
    },
    heading: {
        flexGrow: 1,
        color: '#606060',
        fontSize: '16px',
        fontFamily: 'CO-Bold',
        lineHeight: '1.6',
        fontWeight: 'normal',
        paddingRight: '1rem',

    }
});

const filtradoTabs = (data: any, ciaGestiona:string): any =>  {
    let filtered = data.filter((cat: any) => {return (cat.ListaNoticias !== null && cat.ListaNoticias.length > 0)})
    return  filtered.length > 0 ? filtered : (ciaGestiona && ciaGestiona!="")? [{
        "Categoria": "Destacados",
        "ListaNoticias": [],
        "Novedad": false,
        "Titulo": "Destacados",
        "Visualizacion": "Noticias"
    }]:[{
        "Categoria": "Noticias",
        "ListaNoticias": [],
        "Novedad": false,
        "Titulo": "Noticias",
        "Visualizacion": "Noticias"
    }];
}

const existeAlgunaNoticia = (data: any):any =>{
    return data.filter((cat: any) => {return (cat.ListaNoticias !== null && cat.ListaNoticias.length > 0)}).length > 0
}

export const MeInteresa = (props: any) => {

    const clases = useStyles();
    const { user, mostrarMeInteresa, ciaGestiona } = useContext(PortalContext);
    const msal = useMsal();

    const { data,error, isValidating } = props.data || props.error ? 
    props 
    : useSWR( mostrarMeInteresa? ['meinteresa', user?.id] : null, () => msal.getTokenSilent().then((token:string)=> api.post("/cache/meinteresa/", { "Entrada": { "AccessToken": token } })), {dedupingInterval: 60000})
        

    let errorMessage = error?.message ? error.message : error?.mensaje ? error.mensaje : error;
    return (
        mostrarMeInteresa || (!mostrarMeInteresa && data?.Salida?.Resultados?.length > 0 && existeAlgunaNoticia(data.Salida.Resultados)) ?
        <div className={clases.root}>
            <div className={clases.tituloPreTabs}>
                <Typography variant="h2" className={clases.heading}>
                    Me interesa
                </Typography>
                {isValidating && !data && !error &&
                    <CircularProgress color="primary" size={16} thickness={2} />
                }
            </div>
            {data?.Salida?.Resultados?.length === 0 && <div className={clases.contenedor}><HomeWidgetVacio mensaje="No hay noticias" /></div>}
            {data?.Salida?.Resultados?.length > 0 && <MeInteresaTabs data={ filtradoTabs(data.Salida.Resultados, ciaGestiona)} vermas={data.Salida.VerMas} />}
            {(!data && errorMessage) && <div className={clases.contenedor}><HomeWidgetError error={errorMessage} /></div> }
        </div > :  null
    )
};